import { Progress } from '@pega/cosmos-react-core';
import React, { useCallback, useEffect } from 'react';
import queryString from 'query-string';
import { getAuthResult } from './TwitterApis';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateBannerInfo } from '../../../redux/actions';
import { appState } from '../../../interfaces/common';
import useLocalTranslation from '../../../hooks/useLocalTranslation';

const TwitterAuthResult: React.FC = () => {
  const sessionId = useSelector((state: appState) => state.sessionId);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const translate = useLocalTranslation();

  const fetchAuthDetails = useCallback(async () => {
    const parsedUrl = queryString.parseUrl(window.location.href);
    const result = await getAuthResult(sessionId, queryString.stringify(parsedUrl.query));
    let response = null;
    const encodedResult: string = result ? result.result : '';
    if (encodedResult) {
      const buff = Buffer.from(encodedResult, 'base64');
      response = JSON.parse(buff.toString());
    } else {
      response = undefined;
    }

    navigate('/');
    if (response?.success) {
      const authMessage = `${translate('auth_successful_for')} ${response?.accounts.join(', ')}`;
      dispatch(updateBannerInfo(authMessage, 'success'));
    } else {
      let errorMessage = '';
      if (response?.code) {
        errorMessage = translate(response.code);
      }
      dispatch(updateBannerInfo(errorMessage, 'urgent'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, sessionId, dispatch]);

  useEffect(() => {
    fetchAuthDetails();
  }, [fetchAuthDetails]);

  return <Progress placement="global" />;
};

export default TwitterAuthResult;
